import React, { Fragment, useState } from "react";
import { json, Link, redirect, ScrollRestoration } from "react-router-dom";

import CreateCpaForm from "../../components/onboardCpa/CreateCpaForm";
import {
  trackConversionHelper,
  CONVERSION_PURPOSES,
  CONVERSION_TYPES,
} from "../../utils/tracking/conversionHelper";
import AdsWebsiteVisit from "../../utils/tracking/AdsWebsiteVisit";

function CreateCpa() {
  return (
    <Fragment>
      <ScrollRestoration />
      <AdsWebsiteVisit />
      <main className="public">
        <section id="container">
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Link to="/">
              <img
                src={`${process.env.PUBLIC_URL}/images/logo_dark_blue.svg`}
                alt="Plaintr Brand"
                style={{ width: "200px" }}
              />
            </Link>
          </div>
          <div className="content create-expert-container">
            <div className="expert-container-left">
              <img
                src={`${process.env.PUBLIC_URL}/images/hero_man.svg`}
                alt="Tax filing professional"
              />
              <h1>Join Plaintr's Network of Certified Tax Pros</h1>
              <p>
                Work with real clients, not cold leads. We hand-match you with
                the right people, streamline your workflow, and give you the
                platform tools you need to grow your practice — on your terms.
              </p>
            </div>
            <CreateCpaForm />
          </div>
        </section>
      </main>
    </Fragment>
  );
}

export default CreateCpa;

export async function action({ request }) {
  const data = await request.formData();
  const operating_as = data.get("operatingAs") ? "BU" : "IN";
  const cpaData = {
    custom_user: {
      first_name: data.get("firstname"),
      last_name: data.get("lastname"),
      email: data.get("email"),
      password: data.get("password"),
    },
    password: data.get("password"),
    license_type: data.get("license_type"),
  };

  const endpointPath = "account/create-cpa";
  const apiBaseUrl = process.env.REACT_APP_API_DOMAIN;
  const urlPath = apiBaseUrl.concat("/", endpointPath);

  const response = await fetch(urlPath, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(cpaData),
  });

  if ([400, 401, 422].includes(response.status)) {
    const errors = await response.json();
    return json({ errors }, { status: response.status });
  }

  // Handle 201 Created - return data for verification flow
  if (response.status === 201) {
    const data = await response.json();

    // Track conversion if campaign parameters are present (fire-and-forget)
    trackConversionHelper(
      CONVERSION_PURPOSES.CREATE_EXPERT_ACCOUNT,
      CONVERSION_TYPES.CLK,
      request.url,
    );

    return json({ status: 201, ...data }, { status: 201 });
  }

  // Handle other success responses (shouldn't happen with verification flow, but kept as fallback)
  if (response.ok) {
    const { token } = await response.json();

    // Track conversion if campaign parameters are present (fire-and-forget)
    trackConversionHelper(
      CONVERSION_PURPOSES.CREATE_EXPERT_ACCOUNT,
      CONVERSION_TYPES.CLK,
      request.url,
    );

    return redirect(
      `/activate/confirmation?token=${encodeURIComponent(token)}`,
    );
  }

  throw json({ message: "Could not create CPA account." }, { status: 500 });
}
